const customModal = {
  props: {
    dynamicClass: ".c-modal.dynamicLoading",
    className: ".tingle-custom-modal-JS",
    classButtonClose: ".tingle-modal__close-JS",
    classVisibleModal: "tingle-modal--visible",
  },

  init: function ($baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-customModal.css", this.props.dynamicClass);

    const $baseFind = $baseDom ? $baseDom : document,
      modals = $baseFind.querySelectorAll(this.props.className);

    if (modals) {
      bcl.u.forEach(modals, this.addCloseEvent.bind(this));
    }
  },

  addCloseEvent: function ($modal) {
    const buttonClose = $modal.querySelector(this.props.classButtonClose);
    if (buttonClose) {
      buttonClose.addEventListener("click", this.closeModal.bind(this));
    }
  },

  closeModal: function (event) {
    const $modal = bcl.u.closest(event.target, this.props.className);
    if ($modal) {
      bcl.u.removeClass($modal, this.props.classVisibleModal);
    }
  },
};

export default customModal;
